import { mapGetters, mapMutations } from "vuex";

export default {
    name: "catalog-list-mobile",
    props: ["list"],
    computed: {
        ...mapGetters({
            showCatalogMenuMobile: "system/showCatalogMenuMobile",
        }),
    },
    watch: {
        $route() {
            this.changeShowCatalogMenuMobile(true);
        },
    },
    methods: {
        ...mapMutations({
            changeShowCatalogMenuMobile: `system/CHANGE_SHOW_CATALOG_MENU_MOBILE`,
        }),
        changeShowCatalogMobile() {
            if (this.showCatalogMenu) {
                this.changeShowCatalogMenuMobile(false);
            } else {
                this.changeShowCatalogMenuMobile(true);
            }
        },
        backToMenu() {
            this.changeShowCatalogMenuMobile(false);
        },
        changeSubMenu(item) {
            this.$router.push({ name: "category-page", params: { categorySlug: item.slug } }).catch(() => {
                console.log("");
            });
        },
    },
};
